export const MAX_RETRY_COUNT = 2;
export const FRAUD_RETRY_CODES = [
    429, // Could be a temporary API throttle breach gone in the next second
    501 // Could be a temporary server error
];
export const EXPONENTIAL_BACKOFF = {
    INITIAL_SECONDS: 1,
    MAX_SECONDS: 4
};
